/*
  AHC restock notify (snippets/ahc-notify.liquid).
  Follows the chosen size. When it's sold out the card shows and posts the email
  to Klaviyo's client back-in-stock endpoint for that exact variant; Klaviyo's
  Back in Stock flow sends the email when the size restocks. That sign-up never
  subscribes anyone. Joining the Club is a separate, explicit choice (an unticked
  box, or a one-tap offer after signing up) that subscribes the email to the
  block's Klaviyo list with custom_source "Restock notify".
  With the sample switcher on, nothing is sent.
*/
(function () {
  'use strict';

  var API = 'https://a.klaviyo.com/client/';
  var REVISION = '2026-07-15';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var OPTIN_KEY = 'ahc-notify-optin';

  function fill(str, vars) {
    return String(str || '').replace(/%(\w+)%/g, function (m, key) {
      return vars[key] != null ? vars[key] : '';
    });
  }

  function post(path, company, body) {
    return fetch(API + path + '?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      // JSON:API type: with this revision Klaviyo's back-in-stock endpoint rejects plain
      // application/json without CORS headers, so the browser reports "Failed to fetch"
      headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISION },
      body: JSON.stringify({ data: body })
    }).then(function (r) {
      if (!r.ok) throw new Error('Klaviyo ' + r.status);
    });
  }

  function subscribeRestock(company, email, variantId) {
    return post('back-in-stock-subscriptions/', company, {
      type: 'back-in-stock-subscription',
      attributes: {
        channels: ['EMAIL'],
        profile: { data: { type: 'profile', attributes: { email: email } } }
      },
      relationships: {
        variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
      }
    });
  }

  function joinList(company, listId, email, source) {
    return post('subscriptions/', company, {
      type: 'subscription',
      attributes: {
        custom_source: source,
        profile: {
          data: {
            type: 'profile',
            attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } }
          }
        }
      },
      relationships: { list: { data: { type: 'list', id: listId } } }
    });
  }

  function init(root) {
    if (root.__ahcNotify) return;
    root.__ahcNotify = true;

    var variants, S;
    try {
      variants = JSON.parse(root.querySelector('[data-ahc-notify-variants]').textContent);
      S = JSON.parse(root.querySelector('[data-ahc-notify-strings]').textContent);
    } catch (e) {
      return;
    }
    // Liquid's t filter HTML-escapes ("We&#39;ll"); these strings go in as textContent
    var decoder = document.createElement('textarea');
    Object.keys(S).forEach(function (key) {
      decoder.innerHTML = S[key];
      S[key] = decoder.value;
    });

    var company = root.getAttribute('data-company');
    var listId = root.getAttribute('data-list');
    var sample = root.hasAttribute('data-switcher');
    var hasSize = root.getAttribute('data-has-size') === 'true';
    var body = root.querySelector('[data-n-body]');
    var idle = root.querySelector('[data-n-idle]');
    var done = root.querySelector('[data-n-done]');
    var doneNote = root.querySelector('[data-n-done-note]');
    var form = root.querySelector('[data-n-form]');
    var input = root.querySelector('[data-n-email]');
    var submit = root.querySelector('[data-n-submit]');
    var error = root.querySelector('[data-n-error]');
    var optinBox = root.querySelector('[data-n-optin]');
    var club = root.querySelector('[data-n-club]');
    var join = root.querySelector('[data-n-join]');
    var clubError = root.querySelector('[data-n-club-error]');
    var clubDone = root.querySelector('[data-n-club-done]');
    var submitLabel = submit.textContent;
    var joinLabel = join ? join.textContent : '';

    var signedUp = {}; // variant id -> email, for this page view
    var lastEmail = '';
    var joined = false;

    function byId(id) {
      for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
      return null;
    }
    var current = byId(Number(root.getAttribute('data-variant')));

    function whatFor(v) {
      return hasSize ? fill(S.size_what, { size: v ? v.title : '' }) : S.it_what;
    }

    function optinMode() {
      return root.getAttribute('data-optin');
    }

    function fake() {
      return new Promise(function (resolve) { setTimeout(resolve, 700); });
    }

    function showError(el, msg) {
      el.textContent = msg;
      el.hidden = !msg;
    }

    function busy(button, on, label) {
      button.disabled = on;
      button.textContent = on ? S.sending : label;
    }

    function joinClub(email) {
      var send = sample ? fake() : joinList(company, listId, email, S.source);
      return send.then(function () {
        joined = true;
        // tie this browser to the profile now that they've asked for email
        if (!sample && window.klaviyo && typeof window.klaviyo.identify === 'function') {
          window.klaviyo.identify({ email: email });
        }
      });
    }

    input.addEventListener('input', function () { showError(error, ''); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (input.value || '').trim();
      if (!EMAIL_RE.test(email)) {
        showError(error, S.error_email);
        input.focus();
        return;
      }
      if (!current) return;
      var target = current;
      var wantsClub = optinMode() === 'checkbox' && optinBox && optinBox.checked && !joined;
      showError(error, '');
      busy(submit, true, submitLabel);
      var restock = sample ? fake() : subscribeRestock(company, email, target.id);
      restock
        .then(function () {
          signedUp[target.id] = email;
          lastEmail = email;
          // the restock sign-up has landed; a failed Club join shouldn't undo it
          return wantsClub ? joinClub(email).catch(function () {}) : null;
        })
        .then(render)
        .catch(function () {
          showError(error, S.error_send);
        })
        .then(function () {
          busy(submit, false, submitLabel);
        });
    });

    if (join) {
      join.addEventListener('click', function () {
        showError(clubError, '');
        busy(join, true, joinLabel);
        joinClub(lastEmail)
          .then(render)
          .catch(function () {
            showError(clubError, S.error_send);
          })
          .then(function () {
            busy(join, false, joinLabel);
          });
      });
    }

    function render() {
      var soldOut = !!current && current.available === false;
      root.toggleAttribute('data-soldout', soldOut);
      root.hidden = !(soldOut || sample);
      body.hidden = !soldOut;

      var what = whatFor(current);
      Array.prototype.forEach.call(root.querySelectorAll('[data-n-text]'), function (el) {
        var key = el.getAttribute('data-n-text');
        if (S[key] != null) el.textContent = fill(S[key], { what: what });
      });

      var email = current && signedUp[current.id];
      idle.hidden = !!email;
      done.hidden = !email;
      if (!email) return;
      doneNote.textContent = fill(S.done_note, { email: email, what: what });
      if (club) club.hidden = joined || optinMode() !== 'after';
      if (clubDone) {
        clubDone.hidden = !joined;
        clubDone.textContent = fill(S.club_done, { email: email });
      }
    }

    // Sample switcher: ?notify_optin=after|checkbox, remembered for the visit
    if (sample) {
      var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-n-optin-mode]'));
      var setMode = function (mode) {
        root.setAttribute('data-optin', mode);
        buttons.forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.getAttribute('data-n-optin-mode') === mode));
        });
        try { sessionStorage.setItem(OPTIN_KEY, mode); } catch (e) {}
        render();
      };
      var start = optinMode();
      try {
        var param = new URLSearchParams(window.location.search).get('notify_optin');
        start = (param && /^(after|checkbox)$/.test(param) && param) || sessionStorage.getItem(OPTIN_KEY) || start;
      } catch (e) {}
      setMode(start);
      buttons.forEach(function (b) {
        b.addEventListener('click', function () { setMode(b.getAttribute('data-n-optin-mode')); });
      });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var data = event && event.data;
        if (!data || !document.contains(root)) return;
        if (data.sectionId && data.sectionId !== root.getAttribute('data-section')) return;
        var v = data.variant;
        current = v ? byId(v.id) || { id: v.id, available: v.available, title: v.title } : null;
        if (v && current) current.available = v.available; // fresher than the page-load JSON
        render();
      });
    }

    render();
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ahc-notify]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('product-info:loaded', initAll); // product swap re-renders the block
  document.addEventListener('shopify:section:load', initAll);
})();
